"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
/**
 * ReportTableView to ReportDto parser
 */
var ReportModelParser = /** @class */ (function () {
    function ReportModelParser() {
    }
    ReportModelParser.parse = function (tableView, defaultCurrencyId) {
        var builder = new idm_reporting_service_client_js_1.ReportDtoBuilder();
        var rowsRootView = tableView.rows;
        for (var i = 0; i < rowsRootView.rows.length; i++) {
            var rowView = rowsRootView.rows[i];
            var rowCategoryDto = rowView.element;
            if (rowView.isRemoved) {
                continue;
            }
            var rowCategoryBuilder = builder.addRowCategory(rowCategoryDto.categoryElementDto.categoryPathHolderId)
                .setFilter(rowCategoryDto.filterTreeDto)
                .setOrderType(rowCategoryDto.orderType)
                .setOtherType(rowCategoryDto.categoryElementDto.otherType)
                .setShowAsType(rowCategoryDto.categoryElementDto.showAsType)
                .setTotalType(rowCategoryDto.categoryElementDto.totalType)
                .setTopCount(rowCategoryDto.categoryElementDto.topCount)
                .setSortMeasurePathHolderId(rowCategoryDto.categoryElementDto.sortMeasurePathHolderId);
            this.parseRowView(rowView, rowCategoryBuilder);
        }
        var columns = tableView.columns;
        for (var i = 0; i < columns.children.length; i++) {
            var columnView = columns.children[i];
            var element = columnView.element;
            var styleDto = columnView.columnStyleDto;
            if (element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                var columnCategoryDto = element;
                var columnCategoryStyleDto = styleDto;
                var columnCategoryWithAddMeasureBuilder = builder.addColumnCategory(columnCategoryDto.categoryElementDto.categoryPathHolderId)
                    .setFilter(columnCategoryDto.filterTreeDto)
                    .setOrderType(columnCategoryDto.orderType)
                    .setOtherType(columnCategoryDto.categoryElementDto.otherType)
                    .setShowAsType(idm_reporting_service_client_js_1.ShowAsType.NONE) // resets show type, when branch has measures
                    .setTotalType(columnCategoryDto.categoryElementDto.totalType)
                    .setTopCount(columnCategoryDto.categoryElementDto.topCount)
                    .setShowOnRowsTotal(columnCategoryDto.showOnRowsTotal)
                    .setSortMeasurePathHolderId(columnCategoryDto.categoryElementDto.sortMeasurePathHolderId);
                /*
                 * sets show type {@see ShowAsType} of the last column categories of the branch
                 * to receive values as list of names and ids, when branch consists only of categories and for that category the view type require icon.
                 * @param columns - all column elements
                 */
                if (this.isLastCategoryInBranch(columnView) && !this.existsMeasureInBranch(columnView) && this.isShowIconRequested(columnView)) {
                    columnCategoryWithAddMeasureBuilder.setShowAsType(idm_reporting_service_client_js_1.ShowAsType.LIST_OF_NAME_IDS);
                }
                this.parseCategoryWithMeasureColumnView(columnView, columnCategoryWithAddMeasureBuilder, defaultCurrencyId);
            }
            else if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                var columnMeasureDto = element;
                var currencyId = columnMeasureDto.currencyId ? columnMeasureDto.currencyId : defaultCurrencyId;
                var columnMeasureBuilder = builder.addColumnMeasure(columnMeasureDto.measurePathHolderId)
                    .setFilter(columnMeasureDto.filterTreeDto)
                    .setOrderType(columnMeasureDto.orderType)
                    .setUserDefinedAggregationType(columnMeasureDto.userDefinedAggregationType)
                    .setShowInPercentage(columnMeasureDto.isShowInPercentage)
                    .setCurrencyId(currencyId)
                    .setShowOnRowsTotal(columnMeasureDto.showOnRowsTotal);
                this.parseMeasureColumnView(columnView, columnMeasureBuilder);
            }
        }
        return builder.build();
    };
    ReportModelParser.parseRowView = function (rowView, builder) {
        for (var i = 0; i < rowView.children.length; i++) {
            var row = rowView.children[i];
            var rowCategoryDto = row.element;
            if (row.isRemoved || !rowCategoryDto) {
                continue;
            }
            var rowCategoryBuilder = builder.addRowCategory(rowCategoryDto.categoryElementDto.categoryPathHolderId)
                .setFilter(rowCategoryDto.filterTreeDto)
                .setOrderType(rowCategoryDto.orderType)
                .setOtherType(rowCategoryDto.categoryElementDto.otherType)
                .setShowAsType(rowCategoryDto.categoryElementDto.showAsType)
                .setTotalType(rowCategoryDto.categoryElementDto.totalType)
                .setTopCount(rowCategoryDto.categoryElementDto.topCount)
                .setSortMeasurePathHolderId(rowCategoryDto.categoryElementDto.sortMeasurePathHolderId);
            this.parseRowView(row, rowCategoryBuilder);
        }
    };
    ReportModelParser.parseCategoryWithMeasureColumnView = function (columnView, builder, defaultCurrencyId) {
        for (var i = 0; i < columnView.children.length; i++) {
            var column = columnView.children[i];
            var element = column.element;
            if (element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                var columnCategoryDto = element;
                var columnCategoryWithAddMeasureBuilder = builder.addColumnCategory(columnCategoryDto.categoryElementDto.categoryPathHolderId)
                    .setFilter(columnCategoryDto.filterTreeDto)
                    .setOrderType(columnCategoryDto.orderType)
                    .setOtherType(columnCategoryDto.categoryElementDto.otherType)
                    .setShowAsType(idm_reporting_service_client_js_1.ShowAsType.NONE)
                    .setTotalType(columnCategoryDto.categoryElementDto.totalType)
                    .setTopCount(columnCategoryDto.categoryElementDto.topCount)
                    .setShowOnRowsTotal(columnCategoryDto.showOnRowsTotal)
                    .setSortMeasurePathHolderId(columnCategoryDto.categoryElementDto.sortMeasurePathHolderId);
                /*
                 * sets show type {@see ShowAsType} of the last column categories of the branch
                 * to receive values as list of names and ids, when branch consists only of categories,
                 * @param columns - all column elements
                 */
                if (this.isLastCategoryInBranch(column) && !this.existsMeasureInBranch(column) && this.isShowIconRequested(column)) {
                    columnCategoryWithAddMeasureBuilder.setShowAsType(idm_reporting_service_client_js_1.ShowAsType.LIST_OF_NAME_IDS);
                }
                this.parseCategoryWithMeasureColumnView(column, columnCategoryWithAddMeasureBuilder, defaultCurrencyId);
            }
            else if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                var columnMeasureDto = element;
                var currencyId = columnMeasureDto.currencyId ? columnMeasureDto.currencyId : defaultCurrencyId;
                var columnMeasureBuilder = builder.addColumnMeasure(columnMeasureDto.measurePathHolderId)
                    .setFilter(columnMeasureDto.filterTreeDto)
                    .setOrderType(columnMeasureDto.orderType)
                    .setUserDefinedAggregationType(columnMeasureDto.userDefinedAggregationType)
                    .setShowInPercentage(columnMeasureDto.isShowInPercentage)
                    .setCurrencyId(currencyId)
                    .setShowOnRowsTotal(columnMeasureDto.showOnRowsTotal);
                this.parseMeasureColumnView(column, columnMeasureBuilder);
            }
        }
    };
    ReportModelParser.parseCategoryColumnView = function (columnView, builder) {
        for (var i = 0; i < columnView.children.length; i++) {
            var column = columnView.children[i];
            var element = column.element;
            if (element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                var columnCategoryDto = element;
                var columnCategoryBuilder = builder.addColumnCategory(columnCategoryDto.categoryElementDto.categoryPathHolderId)
                    .setFilter(columnCategoryDto.filterTreeDto)
                    .setOrderType(columnCategoryDto.orderType)
                    .setOtherType(columnCategoryDto.categoryElementDto.otherType)
                    .setShowAsType(idm_reporting_service_client_js_1.ShowAsType.NONE)
                    .setTotalType(columnCategoryDto.categoryElementDto.totalType)
                    .setTopCount(columnCategoryDto.categoryElementDto.topCount)
                    .setShowOnRowsTotal(columnCategoryDto.showOnRowsTotal)
                    .setSortMeasurePathHolderId(columnCategoryDto.categoryElementDto.sortMeasurePathHolderId);
                /*
                 * sets show type {@see ShowAsType} of the last column categories of the branch
                 * to receive values as list of names and ids, when branch consists only of categories,
                 * @param columns - all column elements
                 */
                if (this.isLastCategoryInBranch(column) && !this.existsMeasureInBranch(column) && this.isShowIconRequested(column)) {
                    columnCategoryBuilder.setShowAsType(idm_reporting_service_client_js_1.ShowAsType.LIST_OF_NAME_IDS);
                }
                this.parseCategoryColumnView(column, columnCategoryBuilder);
            }
        }
    };
    ReportModelParser.parseMeasureColumnView = function (columnView, builder) {
        for (var i = 0; i < columnView.children.length; i++) {
            var column = columnView.children[i];
            var element = column.element;
            if (element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                var columnCategoryDto = element;
                var columnCategoryBuilder = builder.addColumnCategory(columnCategoryDto.categoryElementDto.categoryPathHolderId)
                    .setFilter(columnCategoryDto.filterTreeDto)
                    .setOrderType(columnCategoryDto.orderType)
                    .setOtherType(columnCategoryDto.categoryElementDto.otherType)
                    .setShowAsType(idm_reporting_service_client_js_1.ShowAsType.NONE)
                    .setTotalType(columnCategoryDto.categoryElementDto.totalType)
                    .setTopCount(columnCategoryDto.categoryElementDto.topCount)
                    .setShowOnRowsTotal(columnCategoryDto.showOnRowsTotal)
                    .setSortMeasurePathHolderId(columnCategoryDto.categoryElementDto.sortMeasurePathHolderId);
                /*
                 * sets show type {@see ShowAsType} of the last column categories of the branch
                 * to receive values as list of names and ids, when branch consists only of categories,
                 * @param columns - all column elements
                 */
                if (this.isLastCategoryInBranch(column) && !this.existsMeasureInBranch(column) && this.isShowIconRequested(column)) {
                    columnCategoryBuilder.setShowAsType(idm_reporting_service_client_js_1.ShowAsType.LIST_OF_NAME_IDS);
                }
                this.parseCategoryColumnView(column, columnCategoryBuilder);
            }
        }
    };
    /**
     * Checks whether selected category is the last one in branch
     * */
    ReportModelParser.isLastCategoryInBranch = function (columnView) {
        return columnView.children.length === 0;
    };
    /**
     * Checks whether branch has measure or not
     * */
    ReportModelParser.existsMeasureInBranch = function (columnView) {
        var hasMeasure = false;
        var current = columnView.parent;
        while (current.element) {
            if (columnView.parent.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                hasMeasure = true;
                break;
            }
            current = current.parent;
        }
        return hasMeasure;
    };
    ReportModelParser.isShowIconRequested = function (columnView) {
        var styleDto = columnView.columnStyleDto;
        if (columnView.element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
            var columnCategoryStyleDto = styleDto;
            return columnCategoryStyleDto.view === idm_report_export_service_client_js_1.ReportElementViewType.BOTH_ICON_AND_VALUE ||
                columnCategoryStyleDto.view === idm_report_export_service_client_js_1.ReportElementViewType.ONLY_ICON;
        }
        return false;
    };
    return ReportModelParser;
}());
exports.ReportModelParser = ReportModelParser;
//# sourceMappingURL=report-model.parser.js.map